import { useThreadRuntime } from "@assistant-ui/react";
import ChevronIcon from "../../../../assets/icons/ChevronIcon";
import { Dropdown, Button } from "antd";
import type { MenuProps } from "antd";
import { NewChatIcon } from "../../../../assets/icons/NewChatIcon";
import VLTooltip from "../../../uikit/VLTooltip";
import { useFloatingHeader } from "../useFloatingHeader";
import styles from "../ChatView.module.scss";
import { useFeatureFlagService } from "../../../../hooks/useFeatureFlagService";
import { VL_CHAT_DEBUG_CONSOLE_ENABLED } from "../../../../helpers/constants/filters";

export default function ThreadHeader() {
  const { handleNewChatClick } = useFloatingHeader();
  const threadRuntime = useThreadRuntime();
  const isDebugEnabled = useFeatureFlagService(
    VL_CHAT_DEBUG_CONSOLE_ENABLED,
  ).enabled;

  const handleHelpClick = () => {
    window.open("https://docs.visual-layer.com", "_blank");
  };

  const handleLogMessages = () => {
    const messages = threadRuntime.getState().messages;
    console.log("VL Chat Messages:", messages);
  };

  const handleLogState = () => {
    const state = threadRuntime.getState();
    console.log("VL Chat State:", state);
  };

  const debugMenuItems: MenuProps["items"] = [
    {
      key: "log-messages",
      label: "Log Messages",
      onClick: handleLogMessages,
    },
    {
      key: "log-state",
      label: "Log State",
      onClick: handleLogState,
    },
  ];

  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logo}>
          <div>VL Chat</div>
          <div className={styles.alphaTag}>PREVIEW</div>
        </div>
        <div className={styles.headerActions}>
          <Button type="text" size="small" onClick={handleHelpClick}>
            Help
          </Button>
          {isDebugEnabled && (
            <Dropdown menu={{ items: debugMenuItems }} trigger={["click"]}>
              <Button type="text" size="small">
                <div>
                  Debug{" "}
                  <span style={{ marginLeft: 4 }}>
                    <ChevronIcon direction="down" />
                  </span>
                </div>
              </Button>
            </Dropdown>
          )}
          <VLTooltip title="New chat">
            <Button
              type="text"
              size="small"
              onClick={handleNewChatClick}
              icon={<NewChatIcon />}
            />
          </VLTooltip>
        </div>
      </div>
    </div>
  );
}
